import { selectedOfficeApi, type IGetSelectedOfficeParams } from './selectedOfficeApi';
import { getOfficeDetail } from './officeDetailApi';
import { getSelectedOfficeWithDetail } from './mergeOfficeDetail';
import { TSelectedOffice } from './types';

function getSelectedOffice(params: IGetSelectedOfficeParams = {}): Promise<TSelectedOffice> {
  // Pass the /auth/me fetch as a promise so getSelectedOfficeWithDetail can run the
  // /office fetch concurrently with it when the flag is on.
  return getSelectedOfficeWithDetail(
    selectedOfficeApi.getSelectedOffice(params),
    params.officeId,
    getOfficeDetail,
  );
}

export const selectedOfficeService = {
  getSelectedOffice,
};
